<template>
<div
  class="dropup"
>
  <div
    class="bulk_action dropdown-toggle"
    id="dropdownMenuButton"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    
  v-if="selectedCampaignList && selectedCampaignList.length>0"
  >
    <span class="text">Bulk Actions</span>
  </div>
    <div class="form-row">
      <div
        class="dropdown-menu remove-style"
        aria-labelledby="dropdownMenuButton"
      >
        <a
          style="cursor: pointer"
          class="dropdown-item"
          :disabled="selectedCampaignList.length < 1"
          @click="
            selectedBulkAction = 'Add tags to campaigns';
            selectAction();
          "
        >
          Add tags to campaigns
        </a>
        <!-- DISABLING ML RELATED COMPONENT (ENG1-2161) -->
        <!-- <a
          v-if="$route.name == 'campaignListPerGroup'"
          style="cursor: pointer"
          class="dropdown-item"
          :disabled="availableCampaignList < 1 || selectedCampaignList.length < 1"
          @click="
            selectedBulkAction = 'Add campaign to campaign group';
            selectAction();
          "
        >
          Add campaign to campaign group
        </a>
        <a
          v-else
          :disabled="selectedBrandProfle && selectedCampaignList.length < 1"
          @click="
            selectedBulkAction = 'Add campaign to campaign group';
            selectAction();
          "
          style="cursor: pointer"
          class="dropdown-item"
        >
          Add campaign to campaign group
        </a>
        <a
          :disabled="selectedCampaignList.length < 1"
          @click="
            selectedBulkAction = 'Remove campaign from campaign group';
            selectAction();
          "
          style="cursor: pointer"
          class="dropdown-item"
        >
          Remove campaign from campaign group
        </a> -->
        <a
          :disabled="selectedCampaignList.length < 1"
          @click="
            selectedBulkAction = 'Create Guardrail';
            selectAction();
          "
          style="cursor: pointer"
          class="dropdown-item"
        >
          Create Guardrail
        </a>
      </div>
    <div v-if="$store.state.isUserPrestige"><PrestigeTagCampaign  ref="tagsPopup" @closeModal="closeModal" /></div>
    <div v-else><TagCampaign ref="tagsPopup" @closeModal="closeModal" /></div>
    
      <AddToCampaignGroupModal
        ref="addCampToCampGroup"
        @editCampaignGroup="editCampaignGroup"
        @hideAddToCampaignGroupModal="hideAddToCampaignGroupModal"
        @bulkCampaignGroupAssociation="bulkCampaignGroupAssociation"
      ></AddToCampaignGroupModal>
      <DeletePopUp
        v-if="isOpenDeleteModal"
        @deleteData="deleteData"
        @hideDeleteModal="hideDeleteModal"
        :deleteMessage="
          deleteMessage ||
          'Are you sure to remove the campaign(s) from the campaign group(s)?'
        "
        :supportMssg="supportMssg"
        headerMssg="Remove campaign group"
      />
    </div>
  </div>
</template>

<script>
import TagCampaign from "./TagCampaign.vue";
import PrestigeTagCampaign from "./PrestigeTagCampaign.vue"
import AddToCampaignGroupModal from "@/components/campaign/AddToCampaignGroupModal.vue";
import DeletePopUp from "../delete/DeletePopUp.vue";
//import AddGuardrail from "@/components/campaign-list/AddGuardrail.vue";

export default {
  name: "CampaignActions",
  components: {
    TagCampaign,
    PrestigeTagCampaign,
    AddToCampaignGroupModal,
    DeletePopUp,
    //AddGuardrail
    AddGuardrail: () => import("@/components/define-guardrail/AddToGuardrail"),
  },
  data() {
    return {
      selectedBulkAction: "Action",
      isOpenDeleteModal: false,
      showguardrail: false,
      supportMssg: "",
      campWithoutCampGrp: [],
      deleteMessage:
        "Are you sure to remove the campaign(s) from the campaign group(s)?",
    };
  },
  computed: {
    selectedCampaignGroup: {
      get() {
        return this.$store.state.latestCampaignGroup;
      },
      set(val) {
        this.$store.state.latestCampaignGroup = val;
      },
    },
    selectedVendorProduct: {
      set(val) {
        this.$store.state.selectedVendorFilter = val;
      },
      get() {
        return this.$store.state.selectedVendorFilter;
      },
    },
    selectedBrandProfle: {
      set(val) {
        this.$store.commit("setSelectedBrandProfile", val);
      },
      get() {
        return this.$store.state.selectedBrandProfle;
      },
    },
    selectedCampaignList: {
      get() {
        return this.$store.state.campaign.campaignToAddToGroupList;
      },
      set(val) {
        this.$store.state.campaign.campaignToAddToGroupList = val;
      },
    },
    availableCampaignList() {
      return this.$store.state.campaign.campaignList
        ? this.$store.state.campaign.campaignList.length
        : 0;
    },
    actionSelectionControl: {
      set(val) {
        this.$store.state.campaign.actionSelectionControl = val;
      },
      get() {
        return this.$store.state.campaign.actionSelectionControl;
      },
    },
  },
  mounted() {},
  methods: {
    updateCampaignGroupList() {
      const vm = this;
      let payload = {
        ams_profile_id: this.$store.state.campaignList[0].profile_id,
      };
      this.$store
        .dispatch("campaign/getCampaignGroupFilterList", payload)
        .then((res) => {});
    },
    selectAction() {
      if (this.selectedBulkAction == "Add tags to campaigns") {
        if(!this.$store.state.isUserPrestige){
					this.$refs["tagsPopup"].getTagsList();
				}
        $("#taggable").modal("show");
      }
      if (this.selectedBulkAction == "Add campaign to campaign group") {
        if (this.$route.name == "campaignListPerGroup") {
          this.$refs["addCampToCampGroup"].fetchCampaignGroupList();
          $("#addToCampaignGroup").modal("show");
        } else {
          $("#addToCampaignGroup").modal("show");
        }
      }
      if (this.selectedBulkAction == "Remove campaign from campaign group") {
        this.updateSupportMessage();
        this.isOpenDeleteModal = true;
      }
      if (this.selectedBulkAction == "Create Guardrail") {
        if (this.$route.name == "campaignListPerGroup") {
          let item =
            this.availableCampaignList > 0
              ? this.$store.state.campaign.campaignList[0]
              : {};
          this.$store.state.searchFilterString = "";
          this.$store.state.selectedBrandProfle = item.ams_profile_id;
          if (this.$store.state.selectedBrandProfle) {
            this.$store.state.selectedCampaignGroupFilter =
              item.campaignGroupId;
          } else {
            this.$store.state.selectedCampaignGroupFilter = "";
          }
          this.$store.state.refreshCampaign = true;
          sessionStorage.setItem(
            "campaign:showPerPage",
            this.$store.state.tempCampGrpShowPerPage || 25
          );
          this.$store.state.tempCampGrpShowPerPage = 25;
          this.$store.state.currentPageNumber = 1;
        } else {
          this.$store.state.refreshCampaign = false;
        }
        this.showguardrail = true;
        let path = '/addEditGuardrail/' + 'null' + '/myAutomation' + '/campaign'
        this.$router.push({ path: path });

        //$('#addGuardrail').modal('show')
      }
    },
    updateSupportMessage() {
      const selectedList = JSON.parse(
        JSON.stringify(this.selectedCampaignList)
      );
      const selectedCampaigns = JSON.parse(
        JSON.stringify(this.$store.state.campaign.campaignList)
      );
      this.campWithoutCampGrp = [];
      selectedList.forEach((selectedId) => {
        return selectedCampaigns.filter((campaign) => {
          if (campaign.campaign_id == selectedId && !campaign.campaignGroupId) {
            this.campWithoutCampGrp.push(campaign.name);
          }
        });
      });
      if (this.campWithoutCampGrp.length == this.selectedCampaignList.length) {
        this.deleteMessage =
          "No selected campaign(s) associated to any campaign group.";
        this.supportMssg = "";
      } else {
        this.supportMssg =
          this.campWithoutCampGrp.length > 1
            ? this.campWithoutCampGrp.join(", ") +
              " campaigns are not assosciated to any campaign group. "
            : this.campWithoutCampGrp.length == 1
            ? this.campWithoutCampGrp[0] +
              " campaign is not associated to any campaign group."
            : "";
      }
    },
    closeModal() {
      $("#taggable").modal("hide");
      this.$store.state.campaign.campaignToAddToGroupList = [];
      this.actionSelectionControl = false;
      this.selectedBulkAction = "Action";
    },
    editCampaignGroup() {
      this.$emit("openCampaignModal");
    },
    hideAddToCampaignGroupModal(data) {
      $("#addToCampaignGroup").modal("hide");
      this.actionSelectionControl = false;
      this.$store.state.campaign.campaignToAddToGroupList = [];
      this.selectedBulkAction = "Action";
    },
    hideDeleteModal() {
      this.isOpenDeleteModal = false;
      this.actionSelectionControl = false;
      this.$store.state.campaign.campaignToAddToGroupList = [];
      this.supportMssg = "";
      this.deleteMessage =
        "Are you sure to remove the campaign(s) from the campaign group(s)?";
      this.campWithoutCampGrp = [];
      this.selectedBulkAction = "Action";
    },
    bulkCampaignGroupAssociation() {
      let vm = this;
      console.log(this.selectedCampaignGroup);
      console.log(this.$store.state.campaign.campaignToAddToGroupList);
      let arr = this.$store.state.campaign.campaignToAddToGroupList;
      var id = this.selectedCampaignGroup;
      this.selectedCampaignGroup = "";
      let payload = {
        campaign_group_id: id,
        campaign_id: arr,
        requestType: "add",
        vendor_id: this.$store.state.selectedVendorFilter,
      };
      if (arr.length) {
        this.$store.commit("showLoadingSpinner", null, {
          root: true,
        });
        this.$store
          .dispatch("campaign/addCampaignToCampaignGroups", payload)
          .then((res) => {
            vm.$store.state.campaign.campaignToAddToGroupList = [];
            vm.$store.dispatch("campaign/getCampaignList", {}).then((res) => {
              console.log(res);
              vm.actionSelectionControl = false;
              vm.selectedBulkAction = "Action";
            });
          });
      }
      $("#addToCampaignGroup").modal("hide");
    },
    deleteData() {
      //	this.hideDeleteModal();
      if (this.campWithoutCampGrp.length == this.selectedCampaignList.length) {
        this.hideDeleteModal();
        return 0;
      }
      let vm = this;
      let arr = this.$store.state.campaign.campaignToAddToGroupList;
      let payload = {
        campaign_group_id: "",
        campaign_id: arr,
        requestType: "del",
        vendor_id: this.$store.state.selectedVendorFilter,
      };
      if (arr.length) {
        this.$store
          .dispatch("campaign/addCampaignToCampaignGroups", payload)
          .then((res) => {
            // javascript:$('.go-popover').popover('hide');
            vm.hideDeleteModal();
            console.log(res);
            vm.$store.dispatch("campaign/getCampaignList", {}).then((res) => {
              console.log(res);
              vm.actionSelectionControl = false;
              vm.selectedBulkAction = "Action";
            });
          });
      }
    },
  },
};
</script>

<style lang="scss">
</style>
